"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var react_1 = __importStar(require("react"));
var Portal_1 = require("../Portal");
var ModalManager_1 = __importDefault(require("./ModalManager"));
var overlayManager = new ModalManager_1.default();
/**
 * An Overlay is used to build the foundations of other components such as
 * Panels, Modals, and Dialogs.
 *
 * @param props
 */
var Modal = function (props) {
    var overlayRef = react_1.useRef(null);
    var onRequestClose = props.onRequestClose, canClose = props.canClose, pointerEventPassthrough = props.pointerEventPassthrough, withDimming = props.withDimming, preventDismissByClickAway = props.preventDismissByClickAway, preventDismissByEsc = props.preventDismissByEsc, isOpen = props.isOpen, divProps = __rest(props, ["onRequestClose", "canClose", "pointerEventPassthrough", "withDimming", "preventDismissByClickAway", "preventDismissByEsc", "isOpen"]);
    var requestOpen = function () {
        overlayManager.addModal(overlayRef.current);
    };
    var requestClose = function (event) {
        if (!overlayManager.isOverlayOnTop(overlayRef.current)) {
            return;
        }
        if (canClose && !canClose(event)) {
            // Asked the parent if we can close, but they said no :(
            return;
        }
        if (onRequestClose) {
            onRequestClose();
        }
        overlayManager.removeModal(overlayRef.current);
    };
    react_1.useEffect(function () {
        var handleKeyDown = function (event) {
            // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
            if ((event.key !== "Escape" && event.key !== "Esc") || preventDismissByEsc) {
                // Not an escape keypress, or don't want to close this overlay by keyboard
                return;
            }
            requestClose(event);
        };
        document.addEventListener("keydown", handleKeyDown);
        return function () {
            document.removeEventListener("keydown", handleKeyDown);
            overlayManager.removeModal(overlayRef.current);
        };
    }, [isOpen]);
    react_1.useEffect(function () {
        if (isOpen) {
            requestOpen();
        }
        else {
            requestClose();
        }
    }, [isOpen]);
    if (!isOpen) {
        return null;
    }
    var handleBackdropClick = function (event) {
        if (!preventDismissByClickAway) {
            requestClose(event);
        }
    };
    return (react_1.default.createElement(Portal_1.Portal, null,
        react_1.default.createElement("div", __assign({}, divProps, { ref: overlayRef, style: pointerEventPassthrough ? undefined : modalStyle }),
            react_1.default.createElement("div", { onClick: handleBackdropClick, style: withDimming ? dimmingBackdropStyle : backdropStyle }),
            props.children)));
};
exports.Modal = Modal;
// TODO Consider if the design team needs to create CSS equivalents for this
var modalStyle = {
    position: "fixed",
    zIndex: 1000,
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
};
var backdropStyle = __assign(__assign({}, modalStyle), { zIndex: -1, backgroundColor: "transparent" });
var dimmingBackdropStyle = __assign(__assign({}, backdropStyle), { backgroundColor: "rgba(0, 0, 0, 0.5)" });
//# sourceMappingURL=Modal.js.map